<template>
  <div class="a">
    <!-- 头部 -->
    <titled :num="4"></titled>
    <span class="apphome">
      <span class="box">
        <div class="tit">
          <!-- <div class="name">设置相关文档</div> -->
          <div class="search-input-btn">
            <div class="input-small" style="margin-right: 12px;">
              <span>文件名：</span>
              <el-input
                v-model="temp.resourceName"
                size="mini"
                clearable
                placeholder="请输入名称"
              ></el-input>
            </div>
            <div class="input-small" style="margin-right: 12px;">
              <span>上传日期：</span>
              <el-date-picker
                v-model="value1"
                size="mini"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="value1Fn"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
            <el-button type="primary" plain size="mini" @click="getList"
              >查询</el-button
            >
            <a :href="hrefed" :download="hrefedName"></a>
          </div>
          <div class="right" style="display: flex;">
            <el-button type="primary" size="mini">添加文档</el-button>
            <input
              style="
            position: absolute; width: 100px; right: 40px; opacity: 0;"
              type="file"
              accept=".pdf .png , .jpg , .doc"
              @change="handleChange"
            />
          </div>
        </div>
        <el-table
          :data="tableData"
          :header-cell-style="{
            color: '#4CA5FF',
            fontFamily: 'MicrosoftYaHeiUI',
            fontSize: '16px',
            fontWeight: 900,
            backgroundColor: '#fff',
          }"
          height="300px"
          style="width: 97%;margin-left: 30px;"
        >
          <template slot="empty">
            <span class="noData">
              <img src="../../assets/noData.png" alt="暂无数据" />
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column prop="resourceName" label="文件名" min-width="180" />
          <el-table-column label="上传日期" width="180">
            <template slot-scope="{ row }">
              <span>{{ row.createTime }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="entityName" label="实体名称" min-width="90" /> -->
          <el-table-column prop="type" label="文档类型" width="90" />
          <el-table-column prop="createPeople" label="创建人" width="90" />

          <el-table-column label="操作" width="90">
            <template slot-scope="{ row }">
              <el-button
                type="success"
                plain
                size="mini"
                @click="downLoad(row.id)"
                :loading="flag"
                >下载</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="paging">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="temp.pageIndex"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="temp.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </span>
    </span>
  </div>
</template>
<script>
import titled from "@/components/module/titled/titled.vue";
import request from "@/api/http.js";
import {
  saveRecord,
  findUnitRecord,
  findUnitMonthlyReport,
} from "@/api/abbNewApi";
import { parseTime } from "@/utils";
export default {
  components: {
    titled,
  },
  data() {
    return {
      flag: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      value1: "",
      total: 10,
      temp: {
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [
        {
          resourceName: "1级文件",
          createTime: "2022-03-11",
          createPeople: 1,
          type: "excel",
        },
        {
          resourceName: "2级文件",
          createTime: "2022-03-12",
          createPeople: 2,
          type: "excel",
        },
        {
          resourceName: "3级文件",
          createTime: "2022-03-13",
          createPeople: 3,
          type: "excel",
        },
      ],
      hrefed: "",
      hrefedName: "",
    };
  },
  //过滤器
  filters: {
    // 转换时间戳
    date_format: function(value) {
      //value就是插值的数据
      let date = new Date(value);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D =
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";

      let h =
        (date.getHours() < 10 ? "0" + date.getHours() : date.getHours()) + ":";
      let m =
        (date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes()) +
        ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
      let strDate = Y + M + D + h + m + s;
      return strDate;
    },
  },
  mounted() {
    this.getList();
  },
  methods: {
    value1Fn(v) {
      this.temp.startTime = "";
      this.temp.endTime = "";
      if (v) {
        this.temp.startTime = new Date(
          parseTime(v[0], "{y}-{m}-{d} 00:00:00")
        ).getTime();
        this.temp.endTime = new Date(
          parseTime(v[1], "{y}-{m}-{d} 23:59:59")
        ).getTime();
      }
    },
    // 上传
    handleChange(ev) {
      const files = ev.target.files;
      console.log("files", files);
      const fileSuffix = files[0].name.substring(
        files[0].name.lastIndexOf(".") + 1
      );

      const whiteList = ["pdf", "doc", "docx", "png", "jpg", "jpeg"];
      //  const whiteList = ["pdf","png","jpg","doc"];
      if (whiteList.indexOf(fileSuffix) === -1) {
        // this.$message({message:"上传文件只能是 pdf、doc、docx、xls、xlsx、jpeg、png、jpg格式" ,type: 'error'});
        this.$message({
          message: "上传文件只能是 pdf、png、doc 、jpg格式",
          type: "error",
        });
        return false;
      }
      const data = new FormData();
      //使用append存储信息，append('键名','键值')
      data.append("file", files[0]);
      data.append("documentType", "electronic");
      console.log(data, "立刻就能看见");
      saveRecord(data).then((res) => {
        if (res.code == 200) {
          this.$message({ message: "上传成功", type: "success" });
          this.getList();
        }
      });
    },
    //分页功能
    handleSizeChange(val) {
      this.temp.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.temp.pageIndex = val;
      this.getList();
    },
    // 获取下载路径
    downLoad(v) {
      var params = {
        pkid: v,
      };
      this.flag = true;
      request({ url: "/file/downloadRecord", method: "get", params }).then(
        (res) => {
          this.flag = false;
          if (res.code == 200) {
            const a = document.createElement("a");
            var d = DWSystemSetting.downloadUrl2 + "/download" + res.data;

            // var d='http:\\\\192.168.124.150:19001/download/default/static/doc/B5A693FA77804BC8BE009D57D0E7A788/测试文件(DOC).doc';
            // var d='http:\\\\192.168.124.150:19001/default/static/report/doc/B5A693FA77804BC8BE009D57D0E7A788/中山市电气2023-01月度报告.doc';

            window.open(d);
            a.href = d;
            this.hrefed = d;

            var name = d.split("/");
            a.download = name[name.length - 1];
            this.hrefedName = name[name.length - 1];

            // a.click()
          }
        }
      );
    },
    getList() {
      var params = this.temp;
      request({ url: "/file/findUnitMonth", method: "get", params }).then(
        (res) => {
          if (res.code == 200) {
            this.tableData = res.data.content;
            this.total = res.data.totalElements;
          }
        }
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.paging {
  display: flex;
  justify-content: flex-end;
  margin: 10px;
}

.box .tit .right {
  margin-left: auto;
}

.box .tit .right i {
  color: #4ca5ff;
  font-size: 0.34rem;
  margin-right: 0.2rem;
  transform: translateY(4px);
}

.box .tit .name {
  font-family: "Microsoft YaHei";
  font-style: normal;
  font-weight: 700;
  font-size: 0.2rem;
  line-height: 0.3rem;
  color: #4ca5ff;
}

.box .tit {
  display: flex;
  align-items: center;
  padding: 0.1rem 0.4rem;
}

.apphome {
  padding: 15px;
  display: flex;
  margin-top: 1rem;
}

.apphome .box {
  height: calc(100vh - 140px);
  overflow: hidden;
  width: 100%;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}
</style>
